import { render, staticRenderFns } from "./ModalAddressVerify.vue?vue&type=template&id=2c21b50e&scoped=true&"
import script from "./ModalAddressVerify.vue?vue&type=script&lang=js&"
export * from "./ModalAddressVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21b50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c21b50e')) {
      api.createRecord('2c21b50e', component.options)
    } else {
      api.reload('2c21b50e', component.options)
    }
    module.hot.accept("./ModalAddressVerify.vue?vue&type=template&id=2c21b50e&scoped=true&", function () {
      api.rerender('2c21b50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/ModalAddressVerify.vue"
export default component.exports